<template>
  <div class="text-center" v-if="show">
    <a :href="url" class="btn btn-outline-info btn-block ripple-parent">Login with Zoho</a>
  </div>
</template>

<script>
import ZohoService from "../Services/ZohoService";

export default {
  name: "ZohoLoginButton",

  data() {
    return {
      show: false,
      url: "",
    }
  },

  mounted() {
    ZohoService.loadConfig().then((url) => {
      this.url = url;
      this.show = true;
    })
  }
}
</script>
